import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBusinessTilaajavastuuIntegrationStatus } from 'scenes/ProjectBank/services/getBusinessTilaajavastuuIntegrationStatus.service';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';

export const loadBusinessTilaajavastuuIntegrationStatus = createAsyncThunk(
  'projectBank/loadBusinessTilaajavastuuIntegrationStatus',
  async (businessId, { getState }) => {
    const selectedProject = selectSelectedProject(getState());

    const effectiveBusinessId = businessId
      ? businessId
      : selectedProject.business_id;

    const businessStatusItem = await getBusinessTilaajavastuuIntegrationStatus(
      effectiveBusinessId
    );

    return {
      businessId: effectiveBusinessId,
      status: businessStatusItem.status,
    };
  }
);
